<template>
  <div class="t-file__upload-zone">
    <input
      class="file-input"
      type="file"
      :accept="acceptFile"
      multiple
      ref="file"
      v-on:change="handleFileUpload()"
    />
    <div class="content">
      <span v-if="files.length === 0">Sélectionner des fichiers</span>
      <div class="file-item" v-for="(file, key) in files" :key="key">
        <img :class="'file_' + key" alt="" />
        <div class="details">
          <span class="info">{{ displayName(file.name) }}</span>
          <svg
            style="cursor: pointer"
            @click.prevent="removeElement(key)"
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="red"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-trash"
          >
            <polyline points="3 6 5 6 21 6"></polyline>
            <path
              d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
            ></path>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    acceptFile: {
      type: String,
      default: ".jpg,.png,.gif",
    },
  },
  data: () => ({}),

  computed: {
    ...mapState("upload", {
      files: (state) => state.files,
    }),
  },

  methods: {
    displayName(name) {
      return name.substring(0, 12) + "...";
    },
    async displayImage(file, key) {
      const preview = document.querySelector(".file_" + key);
      let fileNmae = file.name.split(".");
      let extFile = fileNmae[fileNmae.length - 1];
      if (["pdf", "doc", "docx", "xls", "xlsx"].includes(extFile)) {
        switch (extFile) {
          case "pdf":
            preview.src = this.$assets("assets/svg/pdf.jpeg");
            break;
          case "doc":
            preview.src = this.$assets("assets/svg/word.jpeg");
            break;
          case "docx":
            preview.src = this.$assets("assets/svg/word.jpeg");
            break;
          case "xls":
            preview.src = this.$assets("assets/svg/excel.jpeg");
            break;
          case "xlsx":
            preview.src = this.$assets("assets/svg/excel.jpeg");
            break;
        }
      } else {
        const reader = new FileReader();
        reader.onloadend = function () {
          preview.src = reader.result;
        };
        if (file) {
          reader.readAsDataURL(file);
        } else {
          preview.src = "";
        }
      }
    },

    handleFileUpload() {
      const accept = this.acceptFile.replaceAll(".", "");
      const ext = accept.split(",");
      let files = this.$refs.file.files;
      files = Array.from(files);
      for (var i = 0; i < files.length; i++) {
        let fileNmae = files[i].name.split(".");
        let extFile = fileNmae[fileNmae.length - 1];
        if (ext.includes(extFile)) {
          this.$store.commit("upload/MUTATE_ADD_FILE", files[i]);
        }
      }
      setTimeout(() => {
        for (var i = 0; i < this.files.length; i++) {
          this.displayImage(this.files[i], i);
        }
      }, 300);
    },

    removeElement(key) {
      this.$store.commit("upload/MUTATE_REMOVE_FILE", key);
      this.files.map((file, key) => {
        this.displayImage(file, key);
      });
    },

    reloadView() {
      this.files.map((file, key) => {
        this.displayImage(file, key);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.t-file__upload-zone {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 20px;
  min-height: 150px;
  height: auto;
  border: 1px dotted #000;
  .file-item {
    width: 100px;
    height: 100px;
    img {
      object-fit: cover;
      height: 80px;
      width: 100px;
    }
    .file-item-remove {
      background: red;
      color: #fff;
      text-align: center;
      width: 100%;
      height: 20px;
      font-size: 11px;
      z-index: 5;
      cursor: pointer;
    }
    .info {
      font-size: 11px;
    }
  }
  .file-input {
    display: block;
    width: 100%;
    opacity: 0;
    cursor: pointer;
    position: absolute;
    padding-left: 20px;
    margin-right: 20px;
    z-index: 2;
  }
  .content {
    position: relative;
    min-height: 150px;
    height: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 20px;
  }
}
.details {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
